import React, {
  PropTypes,
  Component
} from 'react';
import {
  connectToStores
} from 'fluxible/addons';
import Home from '../components/Home';
import Search from '../components/Search';

class HomePage extends Component {
  static propTypes = {
    home: PropTypes.array.isRequired
  }

  static defaultProps = {
    home: [],
    props_data: []
  }

  componentDidUpdate() {
    $(".whirly-loader").css('visibility', 'hidden');
  }

  render() {
    var home = this.props.home.entity.data;
    var props_data = {
      'entity': home
    };
    var userfavourite = {};
    var searchdata = {
      'userfavourite': userfavourite
    };
    if (userfavourite.length > 0) {
      return (
        <Search entities={ searchdata } />
      );
    }
    return (<Home entities={ props_data } />);
  }
}

HomePage = connectToStores(HomePage, ['HomeStore'], (stores, props) => {
  return {
    home: stores.HomeStore.get()
  };
});

export default HomePage;


// WEBPACK FOOTER //
// ./src/pages/HomePage.js